import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';

import Label from 'components/Label';

import { BsUpload } from 'react-icons/bs';
import Text from '../Text';

import { ContainerFile, IconContainer, TextContainer } from './styles';

const MAX_FILE_SIZE = 10 * 1024 * 1024;

function UploadInput({
  name,
  label,
  onChange,
  id,
  accept = '*',
  error,
  ignoreValidation,
  labelColor,
  textColor,
}) {
  const [sizeFileGreater, setSizeFileGreater] = useState(false);
  const [fileName, setFileName] = useState('');

  function handleFileName(files) {
    if (files?.length > 1) {
      setFileName(`${files?.length} arquivos selecionados`);
    } else {
      const [file] = files;
      setFileName(file?.name);
    }
  }

  function handleChange(event) {
    const files = [...event.target.files];

    const hasFileGreater = files.some((file) => file.size > MAX_FILE_SIZE);
    if (!ignoreValidation && hasFileGreater) {
      setSizeFileGreater(true);
      return;
    }

    onChange?.({ target: { files } }, hasFileGreater);
    handleFileName(files);
    setSizeFileGreater(false);
  }

  const inputId = id || name;
  const normalizedAccept = Array.isArray(accept) ? accept.join(',') : accept;

  return (
    <>
      <Label
        htmlFor={inputId}
        className="textLabel"
        style={labelColor ? { color: labelColor } : undefined}
      >
        {label}
      </Label>
      <ContainerFile display={12} as="label" htmlFor={inputId}>
        <Form.Control
          type="file"
          name={name}
          id={inputId}
          onChange={handleChange}
          accept={normalizedAccept}
        />
        <TextContainer>
          <IconContainer>
            <BsUpload size={18} color={textColor || '#494950'} />
          </IconContainer>
          <Text fontSize={14} type="label" color={textColor || '#494950'}>
            Selecione
          </Text>
        </TextContainer>

        {error ? (
          <Text color="error" type="label">
            {error}
          </Text>
        ) : sizeFileGreater ? (
          <Text color="error" type="label">
            Limite de tamanho ultrapassado.
          </Text>
        ) : (
          <Text color={textColor || '#494950'} type="label">
            {fileName}
          </Text>
        )}
      </ContainerFile>
    </>
  );
}

export default UploadInput;
